import React from 'react';
import Icon from '../Icon';
import ButtonStyle from './styles';

const Button = ({ children, loading, ...rest }) => {
  const {
    icon, shape, size, type,
  } = rest;
  const className = [
    'vb-btn',
    size && `vb-btn-${size}`,
    shape && `vb-btn-${shape}`,
    type && `vb-btn-${type}`,
    loading && 'vb-btn-loading',
  ].filter((i) => i).join(' ');
  return (
    <ButtonStyle
      {...rest}
      className={className}
    >
      {icon && <Icon type={icon} /> }
      {children}
    </ButtonStyle>
  );
};

export default Button;
